import { createAction } from 'redux-actions';

import * as types from './types';

export const mergeEntities = createAction(types.MERGE_ENTITIES);
export const replaceEntities = createAction(types.REPLACE_ENTITIES);
